import { createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../../data/axiosInstance/axiosInstance'; 
import executor from   '../../../data/axiosInstance/executor';

const API_URL = `${process.env.REACT_APP_API_SINISTRI_URL}`;
 
const initialState = {
  listaSinistri: []
};

export const RicercaSinistriSlice = createSlice({
  name: 'ricerca-sinistri',
  initialState,
  reducers: {
    getListaRicercaSinistri: (state, action) => {
      //state.allegati = [];
      state.listaSinistri = action.payload;
    }
  }
});

export const { getListaRicercaSinistri } = RicercaSinistriSlice.actions;

export const fetchRicercaSinistri = (selectedOption, value, t) => async (dispatch) => {   
  dispatch(getListaRicercaSinistri([]));
  let uriCall;
  if(selectedOption === t('layouts.components.gridTask.ricercaSinitro.formGroup.value_numeroPolizza')){
    uriCall = `cercaSinistri/numeroPolizza/${value}`;
  } else if(selectedOption === t('layouts.components.gridTask.ricercaSinitro.formGroup.value_cercaPerId')) {
    uriCall = `cercaSinistri/idTask/${value}`;
  } else if(selectedOption === t('layouts.components.gridTask.ricercaSinitro.formGroup.value_numeroSinistro')) {
    uriCall = `cercaSinistri/sinistroId?idPerSinistro=${value}`;
  } else if(selectedOption === t('layouts.components.gridTask.ricercaSinitro.formGroup.value_contraente')) {
    uriCall = `cercaSinistri/contraente/${value}`;
  } else if (selectedOption === t('layouts.components.gridTask.ricercaSinitro.formGroup.value_numeroSinistroExternal')) {
    uriCall = `cercaSinistri/numeroSinistroExternal/${value}`;
  } else if (selectedOption === t('layouts.components.gridTask.ricercaSinitro.formGroup.value_codiceDelegataria')) {
    uriCall = `cercaSinistri/codiceDelegataria/${value}`;
  }  else if (selectedOption === t('layouts.components.gridTask.ricercaSinitro.formGroup.value_numeroSinistroBroker')) {
    uriCall = `cercaSinistri/num_sinistro_broker/${value}`;
  }

  if(value){
    const API_URI_CALL = `${API_URL}/api/v1/bff/denunce/${uriCall}`;
    const fetchData = async  () => axiosInstance.get(API_URI_CALL);
    const [res, err] = await executor.executeAsync(fetchData);

    console.log('res',res); 
    console.log('err',err);
    if(res?.data?.length > 0){
      return dispatch(getListaRicercaSinistri(res.data))
    }
  }

  return null;
  
 /*  return dispatch(getListaRicercaSinistri(
    [
      { id: "10", numeroPolizza: "20", numeroSinistro: "30", esito: "test" },
      { id: "100", numeroPolizza: "200", numeroSinistro: "300", esito: "test2" }
    ]
  ));    */
}; 

export default RicercaSinistriSlice.reducer;
